import { createSelector } from '@reduxjs/toolkit';
import { formatPrice } from '../../helpers/formatters/formatPrice/formatPrice';
import { Price, StoreLoading } from '../types';
import { Summary, SummaryStoreState } from './types';

type SummarySelectors = {
  selectLoading: (state: SummaryStoreState) => StoreLoading;
  selectSummary: (state: SummaryStoreState) => Summary;
  selectPreorderCount: (state: SummaryStoreState) => number;
  selectTotalPrice: (state: SummaryStoreState) => Price;
  selectIsCartInstallmentAvailable: (
    state: SummaryStoreState
  ) => boolean;
  selectIsERecipeAvailable: (
    state: SummaryStoreState
  ) => boolean;
  selectHasQuantity: (state: SummaryStoreState) => boolean;
};

const selectTotalPrice = createSelector(
  (state: SummaryStoreState) => state.entity,
  (entity) =>
    (entity
      ? entity?.summary
      : {
          value: 0,
          valueFormatted: formatPrice(0)
        }) as Price
);

export default {
  selectLoading: (state) => state.loading,

  selectSummary: (state) => state.entity,

  selectPreorderCount: (state) =>
    state.entity?.preorderProductsCount || 0,

  selectTotalPrice,

  selectIsCartInstallmentAvailable: (state) =>
    state.entity?.isCartInstallmentAvailable || false,

  selectIsERecipeAvailable: (state) =>
    state.entity?.isERecipeAvailable || false,

  selectHasQuantity: (state) =>
    typeof state.entity?.quantity === 'undefined'
      ? true
      : state.entity.quantity > 0
} as SummarySelectors;
